import React from 'react';
import './EstadoErro.css';

/**
 * Estado de erro padronizado para telas e listas.
 *
 * Props:
 * - mensagem: texto principal do erro (padrão: mensagem genérica)
 * - detalhe: texto secundário opcional (ex.: detalhe técnico)
 * - onRetry: callback do botão "Tentar novamente" (botão só aparece se informado)
 * - rotuloRetry: rótulo do botão de retry (padrão: "Tentar novamente")
 * - iconeRetry: classe Font Awesome do ícone do botão (padrão: "fa-solid fa-rotate-right").
 *   Use quando a ação não for um retry literal (ex.: navegação → "fa-solid fa-arrow-left").
 * - fullPage: quando true, ocupa a tela inteira; caso contrário, modo inline (card)
 */
function EstadoErro({
  mensagem = 'Não foi possível carregar as informações.',
  detalhe,
  onRetry,
  rotuloRetry = 'Tentar novamente',
  iconeRetry = 'fa-solid fa-rotate-right',
  fullPage = false,
}) {
  const classe = fullPage ? 'estado-erro estado-erro--full' : 'estado-erro estado-erro--inline';

  return (
    <div className={classe} role="alert">
      <i className="fa-solid fa-triangle-exclamation estado-erro__icone" aria-hidden="true" />
      <p className="estado-erro__mensagem">{mensagem}</p>
      {detalhe && <p className="estado-erro__detalhe">{detalhe}</p>}
      {onRetry && (
        <button type="button" className="btn-primary estado-erro__botao" onClick={onRetry}>
          <i className={iconeRetry} aria-hidden="true" /> {rotuloRetry}
        </button>
      )}
    </div>
  );
}

export default EstadoErro;
